var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCirclesThree(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 10.125C14.0711 10.125 15.75 8.44607 15.75 6.375C15.75 4.30393 14.0711 2.625 12 2.625C9.92893 2.625 8.25 4.30393 8.25 6.375C8.25 8.44607 9.92893 10.125 12 10.125Z",
    stroke: "#35383D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.625 19.875C19.6961 19.875 21.375 18.1961 21.375 16.125C21.375 14.0539 19.6961 12.375 17.625 12.375C15.5539 12.375 13.875 14.0539 13.875 16.125C13.875 18.1961 15.5539 19.875 17.625 19.875Z",
    stroke: "#35383D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.375 19.875C8.44607 19.875 10.125 18.1961 10.125 16.125C10.125 14.0539 8.44607 12.375 6.375 12.375C4.30393 12.375 2.625 14.0539 2.625 16.125C2.625 18.1961 4.30393 19.875 6.375 19.875Z",
    stroke: "#35383D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirclesThree);
export default __webpack_public_path__ + "static/media/CirclesThree.f75c39e3b584073a9a64ab47d0ad2d6e.svg";
export { ForwardRef as ReactComponent };